// extracted by mini-css-extract-plugin
module.exports = {"sidebarLink":"styles__sidebarLink___1KwyW","sidebarLinkActive":"styles__sidebarLinkActive___FndnQ styles__sidebarLink___1KwyW"};